"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DataSourceSchema = void 0;
const zod_1 = require("zod");
exports.DataSourceSchema = zod_1.z.enum(['akeneo', 'ipro', 'stub', 'mix']);
exports.default = exports.DataSourceSchema;
//# sourceMappingURL=DataSourceSchema.js.map